import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../../services/api";
import "./TeacherSalaryDashboard.css";

export default function TeacherSalaryDashboard() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const schoolId = school?.school?.id;

  // ===== CURRENT MONTH (YYYY-MM) =====
  const today = new Date();
  const currentMonth = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}`;

  const [month, setMonth] = useState(currentMonth);
  const [totalTeachers, setTotalTeachers] = useState(0);
  const [pending, setPending] = useState(0);
  const [paid, setPaid] = useState(0);

  // ===== SAFE ARRAY HANDLER =====
  const fixArray = (data) => {
    if (Array.isArray(data)) return data;
    if (data?.pending) return data.pending;
    if (data?.paid) return data.paid;
    if (data?.result) return data.result;
    if (data?.salaries) return data.salaries;
    return [];
  };

  // ===== LOAD DASHBOARD DATA =====
  const loadSummary = async () => {
    try {
      // TOTAL TEACHERS
      const resTeachers = await API.get("/school-admin/teachers/", {
        headers: { "X-SCHOOL-ID": schoolId },
      });
      setTotalTeachers(resTeachers.data.teachers.length);

      const [yearStr] = month.split("-");
      const year = Number(yearStr) || today.getFullYear();

      // PENDING
      const resPending = await API.get("/school-admin/salary/pending/", {
        headers: { "X-SCHOOL-ID": schoolId },
        params: { month, year },
      });
      setPending(fixArray(resPending.data).length);

      // PAID
      const resPaid = await API.get("/school-admin/salary/paid/", {
        headers: { "X-SCHOOL-ID": schoolId },
        params: { month, year },
      });
      setPaid(fixArray(resPaid.data).length);
    } catch (err) {
      console.error("Teacher salary dashboard error:", err);
    }
  };

  useEffect(() => {
    loadSummary();
  }, [month]);

  return (
    <div className="tsd-wrap">
      <h2 className="tsd-title">Teacher Salary Dashboard</h2>

      {/* ===== MONTH FILTER ===== */}
      <div className="tsd-filter">
        <label>Select Month</label>
        <input
          type="month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        />
        <p className="tsd-note">
          Showing salary summary for selected month
        </p>
      </div>

      {/* ===== SUMMARY GRID ===== */}
      <div className="tsd-grid">
        <div className="tsd-card total">
          <h3>Total Teachers</h3>
          <p>{totalTeachers}</p>
        </div>

        <div className="tsd-card pending">
          <h3>Pending Salaries</h3>
          <p>{pending}</p>
        </div>

        <div className="tsd-card paid">
          <h3>Paid Salaries</h3>
          <p>{paid}</p>
        </div>
      </div>

      {/* ===== ACTION BUTTONS ===== */}
      <div className="tsd-actions">
        <Link
          to={`/school-admin/salary/pending?month=${month}`}
          className="tsd-btn secondary"
        >
          View Pending
        </Link>

        <Link
          to={`/school-admin/salary/paid?month=${month}`}
          className="tsd-btn secondary"
        >
          View Paid
        </Link>

        <Link
          to="/school-admin/salary/generate"
          className="tsd-btn primary"
        >
          Generate Salary
        </Link>
      </div>
    </div>
  );
}